var map = {
	"./goldcoin/boost-list-icon-2.png": 81890,
	"./memetown/boost-list-icon-2.png": 11355,
	"./reflection/boost-list-icon-2.png": 57204,
	"./tapcoin/boost-list-icon-2.png": 72043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6706;